export const TYPING_PRESENCE_REFRESH_INTERVAL_MS = 1500;

export interface TypingPresenceScheduler {
  recordKeystroke(): void;
  dispose(): void;
}

interface TypingPresenceSchedulerOptions {
  sendTyping(): void;
  refreshIntervalMs?: number;
  now?: () => number;
}

/**
 * Throttles typing presence RPCs so we send at most once per refresh interval.
 * Does NOT send a clear event — the backend expires typing entries automatically
 * via a Redis sorted-set TTL (see {@link TYPING_DEBOUNCE_MS} in presence.service.ts).
 */
export function createTypingPresenceScheduler({
  sendTyping,
  refreshIntervalMs = TYPING_PRESENCE_REFRESH_INTERVAL_MS,
  now = Date.now,
}: TypingPresenceSchedulerOptions): TypingPresenceScheduler {
  let lastTypingSentAt = -Infinity;

  return {
    recordKeystroke() {
      const currentTime = now();
      if (currentTime - lastTypingSentAt >= refreshIntervalMs) {
        lastTypingSentAt = currentTime;
        sendTyping();
      }
    },
    dispose() {
      lastTypingSentAt = -Infinity;
    },
  };
}
